module.exports = __webpack_public_path__ + "img/full5-min.f2640774.png";